import React, { useState, useRef, useCallback } from 'react';
import List from '../../grid.component';
import DepositCode from './deposit';
import { AddressHandler, DepositHandler } from './service';
import { useParams } from 'react-router-dom';
const Wallets = () => {
  const gridRef = useRef(null);
  const [copied, setCopied] = useState('')
  const [walletData, setWalletData] = useState(null)
  const [open, setOpen] = useState(false)
  const params = useParams();
  const programId=params?.id;
  const openModel = useCallback((obj) => () => {
    setOpen(true)
    setWalletData(obj)
  }, [])
  const closeModel = useCallback(() => {
    setOpen(false)
    setWalletData(null)
  }, [])
  const handleCopy = useCallback((id) => () => {
    setCopied(id);
    setTimeout(() => {
      setCopied('');
    }, 1000)
  }, [])
  const addressHandler = useCallback((props) => {
    return <AddressHandler data={props?.dataItem} handleCopy={handleCopy} copied={copied} />
  }, [copied, handleCopy])
  const depositHandler = useCallback((props) => {
    return <DepositHandler data={props?.dataItem} openModel={openModel} />
  }, [copied, handleCopy])
  const customcells = {
    "address": addressHandler,
    "": depositHandler
  };
  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [customcells]);
  return (
    <div className=''>
      <div className="mt-3 wallets-grid">
        <List
          pSize={10}
          className=""
          pKey={"Program_Wallets"}
          ref={gridRef}
          screenName={'Program_Wallets'}
          renderCustomCell={renderCustomCell}
          style={{ width: '100%' }}
          showDisplayColumns={false}
          url={process.env.REACT_APP_API_END_POINT + `/api/CardsActivityService/ProgramWallets/${programId}`} />
      </div>
      <DepositCode open={open} closeModel={closeModel} WalletData={walletData} />
    </div>
  );
}
export default Wallets;